import script from "./DecisionOption.vue?vue&type=script&setup=true&lang=js"
export * from "./DecisionOption.vue?vue&type=script&setup=true&lang=js"

import "./DecisionOption.vue?vue&type=style&index=0&id=6a621cac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a621cac"]])

export default __exports__